export const loadFile = (file) =>
{
    return fetch(file)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Unable to load ${file} response was not ok`);
        }
        return response.json();
      })
}

export const LabInformationBackendService = {
  loadConfigFile: () => {
    return loadFile(`config.json`);
  },
  // geting labels json from static json file in public folder
  loadLabelsFile: (labelInfoFile) =>{
    return loadFile(labelInfoFile);
  }
}

